export default Object.freeze([
    {
        "en": "Afghanistan",
        "zh": "阿富汗",
        "country_code": "AF",
        "code": "93"
    },
    {
        "en": "Alaska",
        "zh": "阿拉斯加",
        "country_code": "US",
        "code": "1907"
    },
    {
        "en": "Albania",
        "zh": "阿尔巴尼亚",
        "country_code": "AL",
        "code": "355"
    },
    {
        "en": "Algeria",
        "zh": "阿尔及利亚",
        "country_code": "DZ",
        "code": "213"
    },
    {
        "en": "American Samoa",
        "zh": "美属萨摩亚",
        "country_code": "AS",
        "code": "1684"
    },
    {
        "en": "Andorra",
        "zh": "安道尔",
        "country_code": "AD",
        "code": "376"
    },
    {
        "en": "Angola",
        "zh": "安哥拉",
        "country_code": "AO",
        "code": "244"
    },
    {
        "en": "Anguilla",
        "zh": "安圭拉",
        "country_code": "AI",
        "code": "1264"
    },
    {
        "en": "Antigua and Barbuda",
        "zh": "安提瓜和巴布达",
        "country_code": "AG",
        "code": "1268"
    },
    {
        "en": "Argentina",
        "zh": "阿根廷",
        "country_code": "AR",
        "code": "54"
    },
    {
        "en": "Armenia",
        "zh": "亚美尼亚",
        "country_code": "AM",
        "code": "374"
    },
    {
        "en": "Aruba",
        "zh": "阿鲁巴",
        "country_code": "AW",
        "code": "297"
    },
    {
        "en": "Ascension",
        "zh": "阿森松",
        "country_code": "SH",
        "code": "247"
    },
    {
        "en": "Australia",
        "zh": "澳大利亚",
        "country_code": "AU",
        "code": "61"
    },
    {
        "en": "Austria",
        "zh": "奥地利",
        "country_code": "AT",
        "code": "43"
    },
    {
        "en": "Azerbaijan",
        "zh": "阿塞拜疆",
        "country_code": "AZ",
        "code": "994"
    },
    {
        "en": "Bahamas",
        "zh": "巴哈马",
        "country_code": "BS",
        "code": "1242"
    },
    {
        "en": "Bahrain",
        "zh": "巴林",
        "country_code": "BH",
        "code": "973"
    },
    {
        "en": "Bangladesh",
        "zh": "孟加拉国",
        "country_code": "BD",
        "code": "880"
    },
    {
        "en": "Barbados",
        "zh": "巴巴多斯",
        "country_code": "BB",
        "code": "1246"
    },
    {
        "en": "Belarus",
        "zh": "白俄罗斯",
        "country_code": "BY",
        "code": "375"
    },
    {
        "en": "Belgium",
        "zh": "比利时",
        "country_code": "BE",
        "code": "32"
    },
    {
        "en": "Belize",
        "zh": "伯利兹",
        "country_code": "BZ",
        "code": "501"
    },
    {
        "en": "Benin",
        "zh": "贝宁",
        "country_code": "BJ",
        "code": "229"
    },
    {
        "en": "Bermuda",
        "zh": "百慕大群岛",
        "country_code": "BM",
        "code": "1441"
    },
    {
        "en": "Bhutan",
        "zh": "不丹",
        "country_code": "BT",
        "code": "975"
    },
    {
        "en": "Bolivia",
        "zh": "玻利维亚",
        "country_code": "BO",
        "code": "591"
    },
    {
        "en": "Bosnia and Herzegovina",
        "zh": "波斯尼亚和黑塞哥维那",
        "country_code": "BA",
        "code": "387"
    },
    {
        "en": "Botswana",
        "zh": "博茨瓦纳",
        "country_code": "BW",
        "code": "267"
    },
    {
        "en": "Brazil",
        "zh": "巴西",
        "country_code": "BR",
        "code": "55"
    },
    {
        "en": "Brunei",
        "zh": "文莱",
        "country_code": "BN",
        "code": "673"
    },
    {
        "en": "Bulgaria",
        "zh": "保加利亚",
        "country_code": "BG",
        "code": "359"
    },
    {
        "en": "Burkina Faso",
        "zh": "布基纳法索",
        "country_code": "BF",
        "code": "226"
    },
    {
        "en": "Burundi",
        "zh": "布隆迪",
        "country_code": "BI",
        "code": "257"
    },
    {
        "en": "Cambodia",
        "zh": "柬埔寨",
        "country_code": "KH",
        "code": "855"
    },
    {
        "en": "Cameroon",
        "zh": "喀麦隆",
        "country_code": "CM",
        "code": "237"
    },
    {
        "en": "Canada",
        "zh": "加拿大",
        "country_code": "CA",
        "code": "1"
    },
    {
        "en": "Cape Verde",
        "zh": "开普",
        "country_code": "CV",
        "code": "238"
    },
    {
        "en": "Cayman Islands",
        "zh": "开曼群岛",
        "country_code": "KY",
        "code": "1345"
    },
    {
        "en": "Central African Republic",
        "zh": "中非共和国",
        "country_code": "CF",
        "code": "236"
    },
    {
        "en": "Chad",
        "zh": "乍得",
        "country_code": "TD",
        "code": "235"
    },
    {
        "en": "China",
        "zh": "中国",
        "country_code": "CN",
        "code": "86"
    },
    {
        "en": "Chile",
        "zh": "智利",
        "country_code": "CL",
        "code": "56"
    },
    {
        "en": "Christmas Island",
        "zh": "圣诞岛",
        "country_code": "CX",
        "code": "6189164"
    },
    {
        "en": "Cocos Island",
        "zh": "科科斯岛",
        "country_code": "CC",
        "code": "6189162"
    },
    {
        "en": "Colombia",
        "zh": "哥伦比亚",
        "country_code": "CO",
        "code": "57"
    },
    {
        "en": "Comoros",
        "zh": "科摩罗",
        "country_code": "KM",
        "code": "269"
    },
    {
        "en": "Cook Islands",
        "zh": "库克群岛",
        "country_code": "CK",
        "code": "682"
    },
    {
        "en": "Costa Rica",
        "zh": "哥斯达黎加",
        "country_code": "CR",
        "code": "506"
    },
    {
        "en": "Croatia",
        "zh": "克罗地亚",
        "country_code": "HR",
        "code": "385"
    },
    {
        "en": "Cuba",
        "zh": "古巴",
        "country_code": "CU",
        "code": "53"
    },
    {
        "en": "Curacao",
        "zh": "库拉索",
        "country_code": "CW",
        "code": "599"
    },
    {
        "en": "Cyprus",
        "zh": "塞浦路斯",
        "country_code": "CY",
        "code": "357"
    },
    {
        "en": "Czech",
        "zh": "捷克",
        "country_code": "CZ",
        "code": "420"
    },
    {
        "en": "Denmark",
        "zh": "丹麦",
        "country_code": "DK",
        "code": "45"
    },
    {
        "en": "Djibouti",
        "zh": "吉布提",
        "country_code": "DJ",
        "code": "253"
    },
    {
        "en": "Dominica",
        "zh": "多米尼加",
        "country_code": "DM",
        "code": "1767"
    },
    {
        "en": "Dominican Republic",
        "zh": "多米尼加共和国",
        "country_code": "DO",
        "code": "1809"
    },
    {
        "en": "Ecuador",
        "zh": "厄瓜多尔",
        "country_code": "EC",
        "code": "593"
    },
    {
        "en": "Egypt",
        "zh": "埃及",
        "country_code": "EG",
        "code": "20"
    },
    {
        "en": "El Salvador",
        "zh": "萨尔瓦多",
        "country_code": "SV",
        "code": "503"
    },
    {
        "en": "Equatorial Guinea",
        "zh": "赤道几内亚",
        "country_code": "GQ",
        "code": "240"
    },
    {
        "en": "Eritrea",
        "zh": "厄立特里亚",
        "country_code": "ER",
        "code": "291"
    },
    {
        "en": "Estonia",
        "zh": "爱沙尼亚",
        "country_code": "EE",
        "code": "372"
    },
    {
        "en": "Ethiopia",
        "zh": "埃塞俄比亚",
        "country_code": "ET",
        "code": "251"
    },
    {
        "en": "Falkland Islands",
        "zh": "福克兰群岛",
        "country_code": "FK",
        "code": "500"
    },
    {
        "en": "Faroe Islands",
        "zh": "法罗群岛",
        "country_code": "FO",
        "code": "298"
    },
    {
        "en": "Fiji",
        "zh": "斐济",
        "country_code": "FJ",
        "code": "679"
    },
    {
        "en": "Finland",
        "zh": "芬兰",
        "country_code": "FI",
        "code": "358"
    },
    {
        "en": "France",
        "zh": "法国",
        "country_code": "FR",
        "code": "33"
    },
    {
        "en": "French Guiana",
        "zh": "法属圭亚那",
        "country_code": "GF",
        "code": "594"
    },
    {
        "en": "French Polynesia",
        "zh": "法属波利尼西亚",
        "country_code": "PF",
        "code": "689"
    },
    {
        "en": "Gabon",
        "zh": "加蓬",
        "country_code": "GA",
        "code": "241"
    },
    {
        "en": "Gambia",
        "zh": "冈比亚",
        "country_code": "GM",
        "code": "220"
    },
    {
        "en": "Georgia",
        "zh": "格鲁吉亚",
        "country_code": "GE",
        "code": "995"
    },
    {
        "en": "Germany",
        "zh": "德国",
        "country_code": "DE",
        "code": "49"
    },
    {
        "en": "Ghana",
        "zh": "加纳",
        "country_code": "GH",
        "code": "233"
    },
    {
        "en": "Gibraltar",
        "zh": "直布罗陀",
        "country_code": "GI",
        "code": "350"
    },
    {
        "en": "Greece",
        "zh": "希腊",
        "country_code": "GR",
        "code": "30"
    },
    {
        "en": "Greenland",
        "zh": "格陵兰岛",
        "country_code": "GL",
        "code": "299"
    },
    {
        "en": "Grenada",
        "zh": "格林纳达",
        "country_code": "GD",
        "code": "1473"
    },
    {
        "en": "Guadeloupe",
        "zh": "瓜德罗普岛",
        "country_code": "GP",
        "code": "590"
    },
    {
        "en": "Guam",
        "zh": "关岛",
        "country_code": "GU",
        "code": "1671"
    },
    {
        "en": "Guatemala",
        "zh": "瓜地马拉",
        "country_code": "GT",
        "code": "502"
    },
    {
        "en": "Guinea",
        "zh": "几内亚",
        "country_code": "GN",
        "code": "224"
    },
    {
        "en": "Guinea-Bissau",
        "zh": "几内亚比绍共和国",
        "country_code": "GW",
        "code": "245"
    },
    {
        "en": "Guyana",
        "zh": "圭亚那",
        "country_code": "GY",
        "code": "592"
    },
    {
        "en": "Haiti",
        "zh": "海地",
        "country_code": "HT",
        "code": "509"
    },
    {
        "en": "Hawaii",
        "zh": "夏威夷",
        "country_code": "US",
        "code": "1808"
    },
    {
        "en": "Honduras",
        "zh": "洪都拉斯",
        "country_code": "HN",
        "code": "504"
    },
    {
        "en": "Hong Kong",
        "zh": "中国香港",
        "country_code": "HK",
        "code": "852"
    },
    {
        "en": "Hungary",
        "zh": "匈牙利",
        "country_code": "HU",
        "code": "36"
    },
    {
        "en": "Iceland",
        "zh": "冰岛",
        "country_code": "IS",
        "code": "354"
    },
    {
        "en": "India",
        "zh": "印度",
        "country_code": "IN",
        "code": "91"
    },
    {
        "en": "Indonesia",
        "zh": "印度尼西亚",
        "country_code": "ID",
        "code": "62"
    },
    {
        "en": "Iran",
        "zh": "伊朗",
        "country_code": "IR",
        "code": "98"
    },
    {
        "en": "Iraq",
        "zh": "伊拉克",
        "country_code": "IQ",
        "code": "964"
    },
    {
        "en": "Ireland",
        "zh": "爱尔兰",
        "country_code": "IE",
        "code": "353"
    },
    {
        "en": "Israel",
        "zh": "以色列",
        "country_code": "IL",
        "code": "972"
    },
    {
        "en": "Italy",
        "zh": "意大利",
        "country_code": "IT",
        "code": "39"
    },
    {
        "en": "Islas Canarias",
        "zh": "加那利群岛",
        "country_code": "ES",
        "code": "34"
    },
    {
        "en": "Ivory Coast",
        "zh": "象牙海岸",
        "country_code": "CI",
        "code": "225"
    },
    {
        "en": "Jamaica",
        "zh": "牙买加",
        "country_code": "JM",
        "code": "1876"
    },
    {
        "en": "Japan",
        "zh": "日本",
        "country_code": "JP",
        "code": "81"
    },
    {
        "en": "Jordan",
        "zh": "约旦",
        "country_code": "JO",
        "code": "962"
    },
    {
        "en": "Kazakhstan",
        "zh": "哈萨克斯坦",
        "country_code": "KZ",
        "code": "7"
    },
    {
        "en": "Kenya",
        "zh": "肯尼亚",
        "country_code": "KE",
        "code": "254"
    },
    {
        "en": "Kiribati",
        "zh": "基里巴斯",
        "country_code": "KI",
        "code": "686"
    },
    {
        "en": "Korea Democratic Rep.",
        "zh": "朝鲜",
        "country_code": "KP",
        "code": "85"
    },
    {
        "en": "Kuwait",
        "zh": "科威特",
        "country_code": "KW",
        "code": "965"
    },
    {
        "en": "Kyrgyzstan",
        "zh": "吉尔吉斯斯坦",
        "country_code": "KG",
        "code": "996"
    },
    {
        "en": "Laos",
        "zh": "老挝",
        "country_code": "LA",
        "code": "856"
    },
    {
        "en": "Latvia",
        "zh": "拉脱维亚",
        "country_code": "LV",
        "code": "371"
    },
    {
        "en": "Lebanon",
        "zh": "黎巴嫩",
        "country_code": "LB",
        "code": "961"
    },
    {
        "en": "Lesotho",
        "zh": "莱索托",
        "country_code": "LS",
        "code": "266"
    },
    {
        "en": "Liberia",
        "zh": "利比里亚",
        "country_code": "LR",
        "code": "231"
    },
    {
        "en": "Libya",
        "zh": "利比亚",
        "country_code": "LY",
        "code": "218"
    },
    {
        "en": "Liechtenstein",
        "zh": "列支敦士登",
        "country_code": "LI",
        "code": "423"
    },
    {
        "en": "Lithuania",
        "zh": "立陶宛",
        "country_code": "LT",
        "code": "370"
    },
    {
        "en": "Luxembourg",
        "zh": "卢森堡",
        "country_code": "LU",
        "code": "352"
    },
    {
        "en": "Macau",
        "zh": "中国澳门",
        "country_code": "MO",
        "code": "853"
    },
    {
        "en": "Macedonia",
        "zh": "马其顿",
        "country_code": "MK",
        "code": "389"
    },
    {
        "en": "Madagascar",
        "zh": "马达加斯加",
        "country_code": "MG",
        "code": "261"
    },
    {
        "en": "Malawi",
        "zh": "马拉维",
        "country_code": "MW",
        "code": "265"
    },
    {
        "en": "Malaysia",
        "zh": "马来西亚",
        "country_code": "MY",
        "code": "60"
    },
    {
        "en": "Maldives",
        "zh": "马尔代夫",
        "country_code": "MV",
        "code": "960"
    },
    {
        "en": "Mali",
        "zh": "马里",
        "country_code": "ML",
        "code": "223"
    },
    {
        "en": "Malta",
        "zh": "马耳他",
        "country_code": "MT",
        "code": "356"
    },
    {
        "en": "Marshall Islands",
        "zh": "马绍尔群岛",
        "country_code": "MH",
        "code": "692"
    },
    {
        "en": "Martinique",
        "zh": "马提尼克",
        "country_code": "MQ",
        "code": "596"
    },
    {
        "en": "Mauritania",
        "zh": "毛里塔尼亚",
        "country_code": "MR",
        "code": "222"
    },
    {
        "en": "Mauritius",
        "zh": "毛里求斯",
        "country_code": "MU",
        "code": "230"
    },
    {
        "en": "Mayotte",
        "zh": "马约特",
        "country_code": "YT",
        "code": "269"
    },
    {
        "en": "Mexico",
        "zh": "墨西哥",
        "country_code": "MX",
        "code": "52"
    },
    {
        "en": "Micronesia",
        "zh": "密克罗尼西亚",
        "country_code": "FM",
        "code": "691"
    },
    {
        "en": "Moldova",
        "zh": "摩尔多瓦",
        "country_code": "MD",
        "code": "373"
    },
    {
        "en": "Monaco",
        "zh": "摩纳哥",
        "country_code": "MC",
        "code": "377"
    },
    {
        "en": "Mongolia",
        "zh": "蒙古",
        "country_code": "MN",
        "code": "976"
    },
    {
        "en": "Montenegro",
        "zh": "黑山",
        "country_code": "ME",
        "code": "382"
    },
    {
        "en": "Montserrat",
        "zh": "蒙特塞拉特岛",
        "country_code": "MS",
        "code": "1664"
    },
    {
        "en": "Morocco",
        "zh": "摩洛哥",
        "country_code": "MA",
        "code": "212"
    },
    {
        "en": "Mozambique",
        "zh": "莫桑比克",
        "country_code": "MZ",
        "code": "258"
    },
    {
        "en": "Myanmar",
        "zh": "缅甸",
        "country_code": "MM",
        "code": "95"
    },
    {
        "en": "Namibia",
        "zh": "纳米比亚",
        "country_code": "NA",
        "code": "264"
    },
    {
        "en": "Nauru",
        "zh": "拿鲁岛",
        "country_code": "NR",
        "code": "674"
    },
    {
        "en": "Nepal",
        "zh": "尼泊尔",
        "country_code": "NP",
        "code": "977"
    },
    {
        "en": "Netherlands",
        "zh": "荷兰",
        "country_code": "NL",
        "code": "31"
    },
    {
        "en": "New Caledonia",
        "zh": "新喀里多尼亚",
        "country_code": "NC",
        "code": "687"
    },
    {
        "en": "New Zealand",
        "zh": "新西兰",
        "country_code": "NZ",
        "code": "64"
    },
    {
        "en": "Nicaragua",
        "zh": "尼加拉瓜",
        "country_code": "NI",
        "code": "505"
    },
    {
        "en": "Niger",
        "zh": "尼日尔",
        "country_code": "NE",
        "code": "227"
    },
    {
        "en": "Nigeria",
        "zh": "尼日利亚",
        "country_code": "NG",
        "code": "234"
    },
    {
        "en": "Niue Island",
        "zh": "纽埃岛(新)",
        "country_code": "NU",
        "code": "683"
    },
    {
        "en": "Norfolk Island",
        "zh": "诺福克岛(澳)",
        "country_code": "NF",
        "code": "6723"
    },
    {
        "en": "Norway",
        "zh": "挪威",
        "country_code": "NO",
        "code": "47"
    },
    {
        "en": "Oman",
        "zh": "阿曼",
        "country_code": "OM",
        "code": "968"
    },
    {
        "en": "Palau",
        "zh": "帕劳",
        "country_code": "PW",
        "code": "680"
    },
    {
        "en": "Panama",
        "zh": "巴拿马",
        "country_code": "PA",
        "code": "507"
    },
    {
        "en": "Papua New Guinea",
        "zh": "巴布亚新几内亚",
        "country_code": "PG",
        "code": "675"
    },
    {
        "en": "Paraguay",
        "zh": "巴拉圭",
        "country_code": "PY",
        "code": "595"
    },
    {
        "en": "Peru",
        "zh": "秘鲁",
        "country_code": "PE",
        "code": "51"
    },
    {
        "en": "Philippines",
        "zh": "菲律宾",
        "country_code": "PH",
        "code": "63"
    },
    {
        "en": "Poland",
        "zh": "波兰",
        "country_code": "PL",
        "code": "48"
    },
    {
        "en": "Portugal",
        "zh": "葡萄牙",
        "country_code": "PT",
        "code": "351"
    },
    {
        "en": "Pakistan",
        "zh": "巴基斯坦",
        "country_code": "PK",
        "code": "92"
    },
    {
        "en": "Puerto Rico",
        "zh": "波多黎各",
        "country_code": "PR",
        "code": "1787"
    },
    {
        "en": "Qatar",
        "zh": "卡塔尔",
        "country_code": "QA",
        "code": "974"
    },
    {
        "en": "Réunion Island",
        "zh": "留尼汪",
        "country_code": "RE",
        "code": "262"
    },
    {
        "en": "Republic Of The Congo",
        "zh": "刚果共和国",
        "country_code": "CG",
        "code": "242"
    },
    {
        "en": "Romania",
        "zh": "罗马尼亚",
        "country_code": "RO",
        "code": "40"
    },
    {
        "en": "Russia",
        "zh": "俄罗斯",
        "country_code": "RU",
        "code": "7"
    },
    {
        "en": "Rwanda",
        "zh": "卢旺达",
        "country_code": "RW",
        "code": "250"
    },
    {
        "en": "Samoa,Eastern",
        "zh": "东萨摩亚(美)",
        "country_code": "AS",
        "code": "684"
    },
    {
        "en": "Samoa",
        "zh": "萨摩亚",
        "country_code": "WS",
        "code": "685"
    },
    {
        "en": "San Marino",
        "zh": "圣马力诺",
        "country_code": "SM",
        "code": "378"
    },
    {
        "en": "Saint Pierre and Miquelon",
        "zh": "圣彼埃尔和密克隆岛",
        "country_code": "PM",
        "code": "508"
    },
    {
        "en": "Sao Tome and Principe",
        "zh": "圣多美和普林西比",
        "country_code": "ST",
        "code": "239"
    },
    {
        "en": "Saudi Arabia",
        "zh": "沙特阿拉伯",
        "country_code": "SA",
        "code": "966"
    },
    {
        "en": "Senegal",
        "zh": "塞内加尔",
        "country_code": "SN",
        "code": "221"
    },
    {
        "en": "Serbia",
        "zh": "塞尔维亚",
        "country_code": "RS",
        "code": "381"
    },
    {
        "en": "Seychelles",
        "zh": "塞舌尔",
        "country_code": "SC",
        "code": "248"
    },
    {
        "en": "Sierra Leone",
        "zh": "塞拉利昂",
        "country_code": "SL",
        "code": "232"
    },
    {
        "en": "Singapore",
        "zh": "新加坡",
        "country_code": "SG",
        "code": "65"
    },
    {
        "en": "Saint Maarten (Dutch Part)",
        "zh": "圣马丁岛（荷兰部分）",
        "country_code": "SX",
        "code": "1721"
    },
    {
        "en": "Slovakia",
        "zh": "斯洛伐克",
        "country_code": "SK",
        "code": "421"
    },
    {
        "en": "Slovenia",
        "zh": "斯洛文尼亚",
        "country_code": "SI",
        "code": "386"
    },
    {
        "en": "Solomon Islands",
        "zh": "所罗门群岛",
        "country_code": "SB",
        "code": "677"
    },
    {
        "en": "Somalia",
        "zh": "索马里",
        "country_code": "SO",
        "code": "252"
    },
    {
        "en": "South Africa",
        "zh": "南非",
        "country_code": "ZA",
        "code": "27"
    },
    {
        "en": "South Korea",
        "zh": "韩国",
        "country_code": "KR",
        "code": "82"
    },
    {
        "en": "Spain",
        "zh": "西班牙",
        "country_code": "ES",
        "code": "34"
    },
    {
        "en": "Sri Lanka",
        "zh": "斯里兰卡",
        "country_code": "LK",
        "code": "94"
    },
    {
        "en": "St.Helena",
        "zh": "圣赫勒拿",
        "country_code": "SH",
        "code": "290"
    },
    {
        "en": "Saint Lucia",
        "zh": "圣露西亚",
        "country_code": "LC",
        "code": "1758"
    },
    {
        "en": "Saint Vincent and The Grenadines",
        "zh": "圣文森特和格林纳丁斯",
        "country_code": "VC",
        "code": "1784"
    },
    {
        "en": "Sudan",
        "zh": "苏丹",
        "country_code": "SD",
        "code": "249"
    },
    {
        "en": "Suriname",
        "zh": "苏里南",
        "country_code": "SR",
        "code": "597"
    },
    {
        "en": "Swaziland",
        "zh": "斯威士兰",
        "country_code": "SZ",
        "code": "268"
    },
    {
        "en": "Sweden",
        "zh": "瑞典",
        "country_code": "SE",
        "code": "46"
    },
    {
        "en": "Switzerland",
        "zh": "瑞士",
        "country_code": "CH",
        "code": "41"
    },
    {
        "en": "Syria",
        "zh": "叙利亚",
        "country_code": "SY",
        "code": "963"
    },
    {
        "en": "Taiwan",
        "zh": "中国台湾",
        "country_code": "TW",
        "code": "886"
    },
    {
        "en": "Tajikistan",
        "zh": "塔吉克斯坦",
        "country_code": "TJ",
        "code": "992"
    },
    {
        "en": "Tanzania",
        "zh": "坦桑尼亚",
        "country_code": "TZ",
        "code": "255"
    },
    {
        "en": "Thailand",
        "zh": "泰国",
        "country_code": "TH",
        "code": "66"
    },
    {
        "en": "Timor-Leste",
        "zh": "东帝汶",
        "country_code": "TL",
        "code": "670"
    },
    {
        "en": "Togo",
        "zh": "多哥",
        "country_code": "TG",
        "code": "228"
    },
    {
        "en": "Tokelau Is.",
        "zh": "托克劳群岛(新)",
        "country_code": "TK",
        "code": "690"
    },
    {
        "en": "Tonga",
        "zh": "汤加",
        "country_code": "TO",
        "code": "676"
    },
    {
        "en": "Trinidad and Tobago",
        "zh": "特立尼达和多巴哥",
        "country_code": "TT",
        "code": "1868"
    },
    {
        "en": "Tunisia",
        "zh": "突尼斯",
        "country_code": "TN",
        "code": "216"
    },
    {
        "en": "Turkey",
        "zh": "土耳其",
        "country_code": "TR",
        "code": "90"
    },
    {
        "en": "Turkmenistan",
        "zh": "土库曼斯坦",
        "country_code": "TM",
        "code": "993"
    },
    {
        "en": "Turks and Caicos Islands",
        "zh": "特克斯和凯科斯群岛",
        "country_code": "TC",
        "code": "1649"
    },
    {
        "en": "Tuvalu",
        "zh": "图瓦卢",
        "country_code": "TK",
        "code": "688"
    },
    {
        "en": "United States",
        "zh": "美国",
        "country_code": "US",
        "code": "1"
    },
    {
        "en": "Uganda",
        "zh": "乌干达",
        "country_code": "UG",
        "code": "256"
    },
    {
        "en": "Ukraine",
        "zh": "乌克兰",
        "country_code": "UA",
        "code": "380"
    },
    {
        "en": "United Kingdom",
        "zh": "英国",
        "country_code": "GB",
        "code": "44"
    },
    {
        "en": "United Arab Emirates",
        "zh": "阿拉伯联合酋长国",
        "country_code": "AE",
        "code": "971"
    },
    {
        "en": "Uruguay",
        "zh": "乌拉圭",
        "country_code": "UY",
        "code": "598"
    },
    {
        "en": "Uzbekistan",
        "zh": "乌兹别克斯坦",
        "country_code": "UZ",
        "code": "998"
    },
    {
        "en": "Vanuatu",
        "zh": "瓦努阿图",
        "country_code": "VU",
        "code": "678"
    },
    {
        "en": "Venezuela",
        "zh": "委内瑞拉",
        "country_code": "VE",
        "code": "58"
    },
    {
        "en": "Vietnam",
        "zh": "越南",
        "country_code": "VN",
        "code": "84"
    },
    {
        "en": "Virgin Islands, British",
        "zh": "英属处女群岛",
        "country_code": "VG",
        "code": "1340"
    },
    {
        "en": "Virgin Islands, US",
        "zh": "美属维尔京群岛",
        "country_code": "VI",
        "code": "1284"
    },
    {
        "en": "Wake I.",
        "zh": "威克岛(美)",
        "country_code": "UM",
        "code": "1808"
    },
    {
        "en": "Yemen",
        "zh": "也门",
        "country_code": "YE",
        "code": "967"
    },
    {
        "en": "Zambia",
        "zh": "赞比亚",
        "country_code": "ZM",
        "code": "260"
    },
    {
        "en": "Zanzibar",
        "zh": "桑给巴尔",
        "country_code": "TZ",
        "code": "259"
    },
    {
        "en": "Zimbabwe",
        "zh": "津巴布韦",
        "country_code": "ZW",
        "code": "263"
    }
]);